import { Controller } from '@hotwired/stimulus'
import AutoNumeric from 'autonumeric'

export default class extends Controller {
  connect() {
    this.autoNumeric = new AutoNumeric(this.element, {
      digitGroupSeparator: '\'',
      decimalCharacter: ',',
      currencySymbol: 'CHF ',
      currencySymbolPlacement: 'p',
      decimalPlaces: 2,
      minimumValue: '0',
    })

    this.hiddenInput = this.findHiddenInput();
    this.syncHiddenInput();

    this.handleValueChange = this.onValueChange.bind(this);
    this.element.addEventListener('autoNumeric:rawValueModified', this.handleValueChange)
  }

  disconnect() {
    this.element.removeEventListener('autoNumeric:rawValueModified', this.handleValueChange)
    this.autoNumeric.remove()
  }

  onValueChange() {
    this.syncHiddenInput();
    this.element.dispatchEvent(new Event('value-change', { bubbles: true }))
  }

  syncHiddenInput() {
    if (!this.hiddenInput) return;
    const rawValue = this.autoNumeric.getNumber();
    this.hiddenInput.value = rawValue ?? '';
  }

  findHiddenInput() {
    if (!this.element.form || !this.element.name) return null;
    return this.element.form.querySelector(`input[type="hidden"][name="${this.element.name}"]`);
  }

  get rawValue() {
    return this.autoNumeric.getNumber()
  }
}
